import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined

const PromotionsList = () => {
    const [promotions, setPromotions] = useState([]);
    const navigate = useNavigate();

    // Fetch promotions data
    useEffect(() => {
        fetch(`${BASE_URL}promotions`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 'success') {
                    setPromotions(data.data || []);
                }
            })
            .catch(error => console.error('Error fetching promotions:', error));
    }, []);

    // Navigate to add promotion page
    const handleAdd = () => {
        navigate('/AddPromotion');
    };

    // Navigate to edit promotion page
    const handleEdit = (id) => {
        navigate(`/EditPromotion/${id}`);
    };

    // Handle delete
    const handleDelete = (id) => {
        if (window.confirm('Are you sure you want to delete this promotion?')) {
            fetch(`${BASE_URL}promotions/${id}`, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
            })
                .then(response => response.json())
                .then(data => {
                    if (data.status === 'success') {
                        setPromotions(promotions.filter((promotion) => promotion.id !== id));
                        alert('Promotion deleted successfully!');
                    } else {
                        alert('Failed to delete promotion.');
                    }
                })
                .catch(error => console.error('Error deleting promotion:', error));
        }
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Promotions List</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb"></ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row" id="basic-table">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label htmlFor="search" className="form-label">Search</label>
                                        <input
                                            type="text"
                                            id="search"
                                            className="form-control"
                                            placeholder="Search by promotion description"
                                        />
                                    </div>
                                    <div className="col-md-6 text-end">
                                        <button className="btn btn-primary" onClick={handleAdd}>Add Promotion</button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table table-lg">
                                        <thead>
                                            <tr>
                                                <th>Description</th>
                                                <th>Discount (%)</th>
                                                <th>From Period</th>
                                                <th>To Period</th>
                                                <th>Happy Hour</th>
                                                <th>Created At</th>
                                                <th className="text-end">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {promotions.map((promotion) => (
                                                <tr key={promotion.id}>
                                                    <td>{promotion.description}</td>
                                                    <td>{promotion.discount_rate}</td>
                                                    <td>{new Date(promotion.from_period).toLocaleString()}</td>
                                                    <td>{new Date(promotion.to_period).toLocaleString()}</td>
                                                    <td>{promotion.happy_hour_from} - {promotion.happy_hour_to}</td>
                                                    <td>{new Date(promotion.created_at).toLocaleString()}</td>
                                                    <td className="text-end">
                                                        <button
                                                            className="btn btn-success"
                                                            onClick={() => handleEdit(promotion.id)}
                                                        >
                                                            Edit
                                                        </button>
                                                        <button
                                                            className="btn btn-danger ms-2"
                                                            onClick={() => handleDelete(promotion.id)}
                                                        >
                                                            Delete
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default PromotionsList;
